import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  HOME_VIEW_ALL_CLICKED,
  HOME_WIDGET_ITEM_TYPE,
} from '@core/constants/analytics';

export const trackHomeViewAllClicked = (
  navigationSource: string,
  count: number
) => {
  analyticsTrackEvent(HOME_VIEW_ALL_CLICKED, {
    itemType: HOME_WIDGET_ITEM_TYPE,
    navigationSource,
    count,
  });
};
